import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { Button } from './ui/Button';
import { colorTokens } from '../app/designTokens';

const { semantic } = colorTokens;

export function TrialConversionConsentPanel({
  eligibility,
  accepted,
  onAcceptedChange,
  onSubmit,
  onRevoke,
  submitting,
}) {
  const { t } = useTranslation('subscriptionChanges');
  const quote = eligibility?.quote;
  const termsVersion = eligibility?.terms_version || '';
  const recordingOpen = eligibility?.consent_recording_open === true && termsVersion !== '';

  return (
    <Box
      sx={{
        mb: 2.5,
        p: 2,
        borderRadius: '12px',
        border: `1px solid ${semantic.border.default}`,
        background: semantic.bg.surface,
      }}
    >
      <Typography sx={{ fontWeight: 700, mb: 1 }}>
        {t('trialConversionTitle')}
      </Typography>
      <Typography sx={{ color: semantic.text.muted, mb: 1.5 }}>
        {t('trialConversionBody')}
      </Typography>
      {quote && (
        <Stack spacing={0.5} sx={{ mb: 1.5 }}>
          <Typography>{t('trialConversionInterval')}: {quote.billing_interval}</Typography>
          <Typography>{t('trialConversionModules')}: {(quote.module_codes || []).join(', ')}</Typography>
          <Typography>{t('trialConversionSeats')}: {quote.users_count}</Typography>
          <Typography>{t('trialConversionPrice')}: {quote.amount} {quote.currency}</Typography>
          <Typography>{t('trialConversionVat')}: {quote.tax_rule || '—'} {quote.tax_rate ?? ''}</Typography>
          <Typography>{t('trialConversionTerms')}: {termsVersion || t('trialConversionLegalPending')}</Typography>
        </Stack>
      )}
      {!recordingOpen && (
        <Typography sx={{ color: semantic.text.muted }}>
          {t('trialConversionLegalPending')}
        </Typography>
      )}
      {recordingOpen && !eligibility?.consent && (
        <Stack spacing={1.5}>
          <Typography sx={{ color: semantic.text.muted }}>
            {t('trialConversionSeparate')}
          </Typography>
          <label>
            <input
              type="checkbox"
              checked={accepted === true}
              onChange={(event) => onAcceptedChange(event.target.checked)}
            />
            {' '}
            {t('trialConversionCheckbox', { version: termsVersion })}
          </label>
          <Box>
            <Button variant="Secondary" disabled={accepted !== true || submitting} onClick={onSubmit}>
              {t('trialConversionSubmit')}
            </Button>
          </Box>
        </Stack>
      )}
      {eligibility?.consent?.status === 'active' && (
        <Box sx={{ mt: 1.5 }}>
          <Button variant="Ghost" disabled={submitting} onClick={onRevoke}>
            {t('trialConversionRevoke')}
          </Button>
        </Box>
      )}
    </Box>
  );
}
